import { cesky } from './i18n';

/**
 * Název sekce: přeložený, pokud ho správkyně nepřejmenovala.
 *
 * Názvy sekcí se dají měnit v administraci a chodí ze serveru. Server je ale
 * zároveň sám zakládá česky, takže „něco přišlo ze serveru" ještě neznamená
 * „někdo si to pojmenoval po svém" – a kdyby vyhrával vždycky, anglická verze
 * by měla polovinu nadpisů česky.
 *
 * Uložená hodnota proto vyhraje jen tehdy, když se liší od obou českých
 * výchozích znění: od toho ve slovníku i od toho, kterým sekci zakládá server.
 * Přejmenovaný název zůstává v obou jazycích – je to vlastní jméno, ne text
 * k překladu.
 */
export function nazevSekce(t, ulozeny, klic, seedovany) {
  const vlastni = ulozeny && ulozeny !== cesky(klic) && ulozeny !== seedovany;
  return vlastni ? ulozeny : t(klic);
}
